import { useRef } from "react";
import { IonContent, IonHeader, IonModal, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { useSchools } from "components/FormFields";
import RequestForm from "components/RequestForm/RequestForm";
import { RequestModel } from "model";

import { Loader } from "~components/Atoms";
import { translate } from "~utils";

export type EditStatus = "Success" | "Cancelled";

type EditRequestModalProps = {
  request: RequestModel;
  onClose: (status: EditStatus) => void;
};

export function EditRequestModal(props: EditRequestModalProps) {
  const { request, onClose } = props;

  /*** Hooks ***/
  const modal = useRef<HTMLIonModalElement>(null);

  /*** Queries ***/
  const schools = useSchools();

  /*** Render ***/
  return (
    <IonModal ref={modal} isOpen={true} onDidDismiss={() => onClose("Cancelled")}>
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{translate("EDIT_REQUEST_HEADER")}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {!schools && <Loader />}

          {schools && (
            <div
              css={{
                paddingTop: 16,
                paddingLeft: 16,
                paddingRight: 16,
                // Increasing the padding bottom since on iOS/Android, with the safe
                // area, there needs more padding so that the button is less close
                // to the bottom screen "---" line
                paddingBottom: 32,
              }}
            >
              <RequestForm
                mode="edit"
                request={request}
                schools={schools}
                onModalDismiss={() => onClose("Cancelled")}
                onModalSuccess={() => onClose("Success")}
              />
            </div>
          )}
        </IonContent>
      </IonPage>
    </IonModal>
  );
}
